import i18n from 'i18next';

import { NO, YES } from '../types/YesOrNo';

export const employmentStatusOptions = [
  {
    name: i18n.t('employmentStatus.employed'),
    value: YES,
  },
  {
    name: i18n.t('employmentStatus.unemployed'),
    value: NO,
  },
];
